import { HOUR_BY_MINUTE_MAP, SERVICES, HOUR_BY_MINUTE_MAP_FULL } from '../components/shared/queueup/queueup-constants';
import { ModalMixin } from './modal';
import { helper } from './helper';
import { mapGetters } from 'vuex';

export const PROVIDER_ORDER_STATUS = {
  REQUESTED: 1,
  ACCEPTED: 2,
  REJECTED: 3,
  IN_PROGRESS: 4,
  COMPLETED: 5,
  CANCELED: 6,
};

export const PROVIDER_TRANSACTION_STATUS = {
  1: 'PENDING',
  2: 'COMPLETE',
  3: 'CANCELED',
};

export const PROVIDER_TRANSACTION_TYPES = {
  COMPLETE: 'COMPLETE',
  PENDING: 'PENDING',
  CANCELED: 'CANCELED',
};

export const PROVIDER_TRANSACTION_SERVICE_TYPES = {
  NORMAL: 1,
  LOBBY_SESSION: 2,
};

export const ProviderMixin = {
  mixins: [ModalMixin, helper],
  data() {
    return {
      PROVIDER_ORDER_STATUS: Object.freeze(PROVIDER_ORDER_STATUS),
      PROVIDER_TRANSACTION_STATUS: Object.freeze(PROVIDER_TRANSACTION_STATUS),
      PROVIDER_TRANSACTION_TYPES: Object.freeze(PROVIDER_TRANSACTION_TYPES),
      PROVIDER_TRANSACTION_SERVICE_TYPES: Object.freeze(PROVIDER_TRANSACTION_SERVICE_TYPES),
    };
  },
  computed: {
    ...mapGetters('profileQueueupQbuddy', ['allowedGames']),
  },
  methods: {
    async isProviderAccountRegistered() {
      let registered = false;
      try {
        const res = await this.$http.get(this.routeProviderAccountRegisterStatus());
        if (res.data.status === 1) {
          registered = true;
        }
      } catch (err) {
        console.log(err);
        // this.providerAPIResponseErrorHandler(err);
      }
      return registered;
    },
    getTransactionStatusByOrderStatus(orderStatus) {
      switch (orderStatus) {
        case PROVIDER_ORDER_STATUS.COMPLETED:
          return PROVIDER_TRANSACTION_TYPES.COMPLETE;
        case PROVIDER_ORDER_STATUS.ACCEPTED:
        case PROVIDER_ORDER_STATUS.REQUESTED:
        case PROVIDER_ORDER_STATUS.IN_PROGRESS:
          return PROVIDER_TRANSACTION_TYPES.PENDING;
        case PROVIDER_ORDER_STATUS.REJECTED:
        case PROVIDER_ORDER_STATUS.CANCELED:
        default:
          return PROVIDER_TRANSACTION_TYPES.CANCELED;
      }
    },
    formatProfileLanguages(values, mapping) {
      return (values && values.length) ? values.filter(e => !!mapping[e]).map(e => mapping[e]).join(' & ') : '';
    },
    formatProfileRegion(value, mapping) {
      return mapping[value] || 'N/A';
    },
    formatDayAvailability({ startMinute, endMinute }, isFull = false) {
      const start = startMinute - startMinute % 60;
      const end = endMinute - endMinute % 60;
      if (end - start === 1440) {
        return 'All day';
      }
      if (isFull) {
        return `${HOUR_BY_MINUTE_MAP_FULL[start]}-${HOUR_BY_MINUTE_MAP_FULL[end]}`;
      }

      return `${HOUR_BY_MINUTE_MAP[start]}-${HOUR_BY_MINUTE_MAP[end]}`;
    },
    getDefaultProviderAvatar() {
      return this.contentCloudFront(`/assets/main_profile/queueup-default-student.png`);
    },
    replaceWithDefaultProviderAvatar(e) {
      e.target.src = this.getDefaultProviderAvatar();
    },
    getAPIErrorResponseMessage(input) {
      if (!input || input === null) {
        return null;
      }
      if (input.errorCode) {
        return input;
      } else if (input.response) {
        if (input.response.data) {
          return input.response.data;
        }
      }
      return null;
    },
    providerAPIResponseErrorHandler(input) {
      const data = this.getAPIErrorResponseMessage(input);
      if (data === null) {
        return;
      }
      let title, message;
      switch (data.errorCode) {
        case 'SERVER_ISSUE':
          title = 'Server Error';
          message = data.msg;
          break;
        case 'CLIENT_ISSUE':
          title = 'Error';
          message = data.msg;
          break;
        default:
          return;
      }
      this.showModalBoomMsg(message, title);
    },
    providerAPIResponseErrorHandlerForClient(input) {
      const data = this.getAPIErrorResponseMessage(input);
      if (data === null) {
        return;
      }
      let title, message;
      switch (data.errorCode) {
        case 'SERVER_ISSUE':
          title = 'Server Error';
          message = data.detail_msg;
          break;
        case 'CLIENT_ISSUE':
          title = 'Invalid Request';
          message = data.detail_msg;
          break;
        default:
          return;
      }
      this.showModalBoomMsg(message, title);
    },
    /**
     * hide or show chat icon on mobile
     * @param {boolean} status : + false: hide chat icon
     *                           + true: show chat icon
     */
    toggleChatIconOnMobile(status) {
      if (!this.checkMobileDevice()){
        return;
      }
      const chatIcon = document.getElementsByClassName('chat_icon_container')[0];
      if (!chatIcon) {
        return;
      }
      if (!status){
        if (!chatIcon.classList.contains('hide')){
          chatIcon.classList.add('hide');
        }
      } else {
        if (chatIcon.classList.contains('hide')){
          chatIcon.classList.remove('hide');
        }
      }
    },
    getServiceName(slug, isQPartner = null) {
      const qpartnerFlag = isQPartner !== null ? isQPartner : (this.userData && this.userData.is_qpartner);
      if (qpartnerFlag && (slug === 'queue-buddy' || slug === 'Queue Buddy')) {
        return 'Queue Partner';
      }
      return SERVICES[slug] || slug;
    },
  },
};
